/* eslint-disable react/no-danger */
import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import EmbeddedVideo from '../../../incase-domain/components/EmbeddedVideo';
import MediaVideo from '../../../incase-domain/components/media/MediaVideo';
import {IElementVideo, VideoSourceType} from '../../../incase-domain/elements/video';
import {getEmbedUrl} from '../../../incase-domain/validators/elements/video';
import {setSelectedElementId} from '../../../store/actions/slide';
import Button from '../../../incase-domain/components/button/Button';

interface ElementVideoComponentProps {
    element: IElementVideo;
}

function ElementVideoComponent(props: ElementVideoComponentProps): ReactElement {
    const {element} = props;
    const {videoSource} = element;

    const {t} = useTranslation();

    const dispatch = useDispatch();

    function getBody(): JSX.Element {
        if (videoSource?.type === VideoSourceType.url && videoSource?.src) {
            return (
                <MediaVideo
                    key={videoSource.src}
                    className="u-events-none"
                    controls
                    autoPlay
                    loop
                    data-testid="video-element"
                    src={videoSource.src}
                    unsupportedText={t('common.unsupportedVideo')}
                />
            );
        }

        if (element.videoSrc) {
            return (
                <MediaVideo
                    className="u-events-none"
                    controls
                    autoPlay
                    loop
                    data-testid="video-element"
                    src={element.videoSrc}
                    unsupportedText={t('common.unsupportedVideo')}
                />
            );
        }

        if (videoSource?.type === VideoSourceType.embedded && videoSource?.src) {
            return <EmbeddedVideo src={getEmbedUrl(videoSource.src)} className="u-events-none" />;
        }

        return (
            <div className="c-videoElement__fileUpload">
                <Button
                    variant="soft"
                    color="secondary"
                    size="2xs"
                    onClick={() => {
                        dispatch(setSelectedElementId(element.id));
                    }}
                >
                    {t('presEditPage.editSidebar.elements.initialStates.video')}
                </Button>
            </div>
        );
    }

    return <div className="c-videoElement">{getBody()}</div>;
}

export default ElementVideoComponent;
